import { IconButton } from '../../../../../../../components/icon-button/icon-button';
import { InlineInputs } from '../../../../../../../components/inline-inputs/inline-inputs';
import { Input } from '../../../../../../../components/input/input';
import { userSocialIcons } from '../../../../../../../helpers/icon-maps';
import s from './profile-socials.module.css';
import { useProfileSocials } from './use-profile-socials';

export const ProfileSocials = () => {
  const { t } = useProfileSocials();

  return (
    <div className={s.feature}>
      <h2>{t('Социальные сети')}</h2>
      <ul className={s.list}>
        {Object.keys(userSocialIcons).map((key) => (
          <InlineInputs key={key}>
            <IconButton className={s.button} variant="secondary" size="lg" tabIndex={-1}>
              {userSocialIcons[key]}
            </IconButton>
            <Input size="lg" disabled />
          </InlineInputs>
        ))}
      </ul>
    </div>
  );
};
